<!-- Construction banner (non-production only) -->
<div
  *ngIf="!isProduction"
  class="construction-banner bg-[url('assets/images/construction.png')] bg-repeat w-full h-1 relative z-50"
></div>

<!-- Show skeleton loading screen while app is initializing -->
<div *ngIf="loadingService.isLoading(); else appLoaded">
  <app-skeleton-with-progress></app-skeleton-with-progress>
</div>

<!-- Show main app content when loaded -->
<ng-template #appLoaded>
  <ngx-loading-bar
    [includeSpinner]="false"
    height="3px"
    color="#000"
    [includeSpinner]="true"
    spin
    class="dark:!bg-white"
  ></ngx-loading-bar>
  <router-outlet></router-outlet>

  <!-- Spartan UI Toaster for notifications -->
  <hlm-toaster richColors />
</ng-template>
